/**
 * 平台: 司机端webview
 * 通用能力:
 * 1.bridge dbridge
 */
import { DriverJump } from './goTo';
import { utils } from '@didi/webx-js-core';
import { storage } from '../../../storage';
function commonJump(loadParams, xenv, commonParams = {}) {
    new DriverJump(loadParams, xenv, commonParams).doJump();
}
import { dbridge } from '@didi/driver-bridge';
import { dbridge as kfdbridge } from '@didi/kf-driver-bridge';
/* 司机端登录 */
const driverLogin = (option, callback) => {
    return new Promise((resolve, reject) => {
        dbridge.getUserInfo({}, res => {
            const { useQuick } = option || {};
            if (res && res.ticket) {
                const userInfo = {
                    token: res.ticket,
                    phone: res.phone
                };
                /* 获取用户信息成功 存入缓存 */
                storage.userInfo = { ...userInfo };
                let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: res.ticket });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                /* 执行传入cb */
                useQuick && callback && callback({ ...userInfo });
                resolve({ ...userInfo });
            }
            else {
                /* 获取用户信息失败 存入缓存 */
                storage.userInfo = {};
                let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: undefined });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                reject({});
            }
        });
    });
};
/* 花小猪司机端登录 */
const kfdriverLogin = (option, callback) => {
    return new Promise((resolve, reject) => {
        kfdbridge.getUserInfo({}, res => {
            const { useQuick } = option || {};
            if (res && res.ticket) {
                const userInfo = {
                    token: res.token || res.ticket,
                    phone: res.phone
                };
                /* 获取用户信息成功 存入缓存 */
                storage.userInfo = { ...userInfo };
                let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: res.token || res.ticket });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                /* 执行传入cb */
                useQuick && callback && callback({ ...userInfo });
                resolve({ ...userInfo });
            }
            else {
                /* 获取用户信息失败 存入缓存 */
                storage.userInfo = {};
                let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: undefined });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                reject({});
            }
        });
    });
};
/* 司机端设置登录信息 */
const driverSetLoginConfig = () => { };
/* 花小猪司机端设置登录信息 */
const kfdriverSetLoginConfig = () => { };
/* 司机端退出登录 */
const driverLogout = () => {
    return new Promise((resolve) => {
        resolve({});
        dbridge.requestLogout({
            tts: '车辆切换成功, 请重新登录'
        });
    });
};
/* 花小猪司机端退出登录 */
const kfdriverLogout = () => {
    return new Promise((resolve) => {
        resolve({});
        kfdbridge.requestLogout({
            tts: '车辆切换成功, 请重新登录'
        });
    });
};
/* 司机端获取定位信息 */
const driverLocate = () => {
    return new Promise((resolve, reject) => {
        dbridge.getLocationInfo({ forceLocation: 1 }, function (res) {
            if (res && (res.lat || res.lng)) {
                /* 获取定位信息成功 存入缓存 */
                storage.locationInfo = {
                    lat: Number(res.lat || 0),
                    lng: Number(res.lng || 0),
                    cityId: Number(res.cityId || 0),
                    area: String(res.area || '')
                };
                let newRiskParams = Object.assign({}, storage.riskParams, { latitude: res.lat, longitude: res.lng, cityId: String(res.cityId) });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                resolve({
                    lat: Number(res.lat || 0),
                    lng: Number(res.lng || 0),
                    cityId: Number(res.cityId || 0),
                    area: String(res.area || '')
                });
            }
            else {
                /* 获取定位信息失败 存入缓存 */
                storage.locationInfo = {};
                let newRiskParams = Object.assign({}, storage.riskParams, { latitude: undefined, longitude: undefined, cityId: undefined });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                reject({});
            }
        });
    });
};
/* 花小猪司机端获取定位信息 */
const kfdriverLocate = () => {
    return new Promise((resolve, reject) => {
        kfdbridge.getLocationInfo({ forceLocation: 1 }, function (res) {
            if (res && (res.lat || res.lng)) {
                /* 获取定位信息成功 存入缓存 */
                storage.locationInfo = {
                    lat: res.lat,
                    lng: res.lng,
                    cityId: res.cityId || res.city_id,
                    area: res.area
                };
                let newRiskParams = Object.assign({}, storage.riskParams, { latitude: res.lat, longitude: res.lng, cityId: String(res.cityId || res.city_id) });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                resolve({
                    lat: res.lat,
                    lng: res.lng,
                    cityId: res.cityId || res.city_id,
                    area: res.area
                });
            }
            else {
                /* 获取定位信息失败 存入缓存 */
                storage.locationInfo = {};
                let newRiskParams = Object.assign({}, storage.riskParams, { latitude: undefined, longitude: undefined, cityId: undefined });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
                reject({});
            }
        });
    });
};
/* 司机端保存图片 */
const driverSaveImg = (url) => {
    return new Promise((resolve, reject) => {
        dbridge.saveImage({
            type: 1,
            data: url
        }, res => {
            if (+res.errno === 0) {
                resolve(res);
            }
            else {
                reject(res);
            }
        });
    });
};
/* 花小猪司机端保存图片 */
const kfdriverSaveImg = (url) => {
    return new Promise((resolve, reject) => {
        kfdbridge.saveImage({
            type: 1,
            data: url
        }, res => {
            try {
                const resObj = JSON.parse(res);
                if (+resObj.status === 0) {
                    resolve(resObj);
                }
                else {
                    reject(resObj);
                }
            }
            catch (e) {
                reject(res);
            }
        });
    });
};
/* 司机端获取系统信息 */
const driverGetSystemInfo = () => {
    return new Promise((resolve, reject) => {
        try {
            dbridge.getSystemInfo(resolve);
        }
        catch (err) {
            reject({ errMsg: err });
        }
    });
};
/* 花小猪司机端获取系统信息 */
const kfdriverGetSystemInfo = () => {
    return new Promise((resolve, reject) => {
        try {
            kfdbridge.getSystemInfo(resolve);
        }
        catch (err) {
            reject({ errMsg: err });
        }
    });
};
const getChannel = (option) => {
    return option && option.channel;
};
/* 司机端设置分享 */
const driverSetShare = (option) => {
    /* 这里是通过setShare收集到的分享动作完成后的回调 */
    /* TODO: 涉及添加多个参数来接收回调 之前K是放在config里 不放在config里则会多出N个参数 */
    dbridge.initEntrance(option);
    dbridge.addCornerButton({
        btnName: '...'
        // @ts-ignore
    }, () => {
        // 点击btn的回调
        dbridge.invokeEntrance();
    });
};
/* 司机端主动分享 */
const driverInvokeShare = (option) => {
    if ('buttons' in option) {
        /* 多渠道invokeShare 拉起面板 */
        dbridge.initEntrance(option);
        dbridge.invokeEntrance(option);
    }
    else if ('channel' in option) {
        /* 单渠道分享 取config中channel作为目标渠道 */
        const method = getChannel(option);
        if (method in dbridge) {
            dbridge[method](option);
        }
    }
};
/* 花小猪司机端设置分享 */
const kfdriverSetShare = (option) => {
    /* 这里是通过setShare收集到的分享动作完成后的回调 */
    /* TODO: 涉及添加多个参数来接收回调 之前K是放在config里 不放在config里则会多出N个参数 */
    kfdbridge.initEntrance(option);
    kfdbridge.addCornerButton({
        btnName: '...'
    }, () => {
        // 点击btn的回调
        kfdbridge.invokeEntrance();
    });
};
/* 花小猪司机端主动分享 */
const kfdriverInvokeShare = (option) => {
    if ('buttons' in option) {
        /* 多渠道invokeShare 拉起面板 */
        kfdbridge.initEntrance(option);
        kfdbridge.invokeEntrance(option);
    }
    else if ('channel' in option) {
        /* 单渠道分享 取config中channel作为目标渠道 */
        const method = getChannel(option);
        if (method in kfdbridge) {
            kfdbridge[method](option);
        }
    }
};
export { dbridge, kfdbridge, driverLogin as driverIsLogin, driverLogin, driverLogout, driverSetLoginConfig, driverLocate, driverSetShare, driverInvokeShare, driverSaveImg, driverGetSystemInfo, kfdriverLogin as kfdriverIsLogin, kfdriverLogin, kfdriverLogout, kfdriverSetLoginConfig, kfdriverLocate, kfdriverSetShare, kfdriverInvokeShare, kfdriverSaveImg, kfdriverGetSystemInfo, commonJump as driverCommonJump };
